module.exports = __webpack_public_path__ + "img/infraestructura-icon.23db5dcd.png";